<p-menubar class="g2fm-menubar" [model]="items">
  <ng-template pTemplate="item" let-item>
    @if (item.display) {
      <ng-container *ngIf="item.route; else elseBlock">
        <a [routerLink]="item.route" class="p-menuitem-link">
          <span [class]="item.icon"></span>
          <span class="ml-2">{{ item.label | transloco}}</span>
        </a>
      </ng-container>
      <ng-template #elseBlock>
        <a class="p-menuitem-link">
          <span [class]="item.icon"></span>
          <span class="ml-2">{{ item.label  | transloco}}</span>
        </a>
      </ng-template>
    }
  </ng-template>
  <ng-template pTemplate="end">
    <div class="flex align-items-center gap-2">
      {{ username }}
      <div class="card flex justify-content-center">
        <p-menu #menuLogin [model]="itemsLogin" [popup]="true">
          <ng-template pTemplate="item" let-itemLogin>
            <a [routerLink]="itemLogin.route" pRipple class="flex align-items-center p-menuitem-link">
              <span [class]="itemLogin.icon"></span>
              <span class="ml-2">{{ itemLogin.label  | transloco}}</span>
            </a>
          </ng-template>
        </p-menu>
        <p-button severity="secondary" (click)="menuLogin.toggle($event)" icon="pi pi-ellipsis-v" />
      </div>
    </div>
  </ng-template>
</p-menubar>
